import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "../styles/Notifications.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import Footer from '../component/footer';

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const cdnURL = process.env.REACT_APP_CDN_URL;

const Notifications = () => {
    const [iusEnNumPages, setIusEnNumPages] = useState(null);
    const [iusBmNumPages, setIusBmNumPages] = useState(null);
    const [numPages, setNumPages] = useState(null);

    return (
        <div className="notifications-page">
            <div className="notifications-container">
                <section className="notification-section">
                    <div className="notification-header">
                        <span className="notification-date">
                            17 September 2026, Thursday
                        </span>

                        <h1>Internet User Survey 2026 (IUS 2026)</h1>
                    </div>

                    {/* English PDF */}
                    <div className="pdf-card">
                        <div className="pdf-card-header">
                            <h2>English</h2>
                        </div>

                        <Document
                            file={`${cdnURL}/pdf/notification-SDID-2026-surveys_ENG.pdf`}
                            onLoadSuccess={({ numPages }) =>
                                setIusEnNumPages(numPages)
                            }
                            loading={
                                <div className="pdf-loading">
                                    Loading PDF...
                                </div>
                            }
                            error={
                                <div className="pdf-error">
                                    Unable to load this PDF.
                                </div>
                            }
                        >
                            <div className="pdf-pages">
                                {Array.from(
                                    { length: iusEnNumPages || 0 },
                                    (_, index) => (
                                        <div
                                            className="pdf-page-wrapper"
                                            key={index}
                                        >
                                            <Page
                                                pageNumber={index + 1}
                                                width={1100}
                                                renderTextLayer={false}
                                                renderAnnotationLayer={true}
                                            />
                                        </div>
                                    )
                                )}
                            </div>
                        </Document>
                    </div>

                    {/* Bahasa Melayu PDF */}
                    <div className="pdf-card">
                        <div className="pdf-card-header">
                            <h2>Bahasa Melayu</h2>
                        </div>

                        <Document
                            file={`${cdnURL}/pdf/notification-SDID-2026-surveys_BM.pdf`}
                            onLoadSuccess={({ numPages }) =>
                                setIusBmNumPages(numPages)
                            }
                            loading={
                                <div className="pdf-loading">
                                    Loading PDF...
                                </div>
                            }
                            error={
                                <div className="pdf-error">
                                    Unable to load this PDF.
                                </div>
                            }
                        >
                            <div className="pdf-pages">
                                {Array.from(
                                    { length: iusBmNumPages || 0 },
                                    (_, index) => (
                                        <div
                                            className="pdf-page-wrapper"
                                            key={index}
                                        >
                                            <Page
                                                pageNumber={index + 1}
                                                width={1100}
                                                renderTextLayer={false}
                                                renderAnnotationLayer={true}
                                            />
                                        </div>
                                    )
                                )}
                            </div>
                        </Document>
                    </div>
                </section>

                <section className="notification-section">
                    <div className="notification-header">
                        <span className="notification-date">
                            17 July 2026, Friday
                        </span>

                        <h1>MCMC - GCC Sub-Code on Opt-In Requirements</h1>
                    </div>

                    <div className="notification-body">
                        <div className="notification-body-content">
                            <div style={{ fontWeight: 'bold' }}>MCMC - GCC Sub-Code on Opt-In Requirements</div><br></br>
                            <div>XOX Mobile wishes to inform our customers that the Communications and Multimedia Consumer Forum of Malaysia (CFM) has introduced the General Consumer Code (GCC) Sub-Code on Opt-In Requirements, which was registered by the Malaysian Communications and Multimedia Commission (MCMC) and came into effect on 25 May 2026.</div><br></br>
                            <div>The Sub-Code aims to strengthen consumer protection by promoting transparent and informed consent practices within the communications and multimedia industry. It supports consumers in making informed choices when subscribing to products and services offered by service providers.</div><br></br>
                            <div>XOX Mobile remains committed to upholding consumer rights and complying with applicable regulatory requirements in delivering our products and services.</div><br></br>
                            <div>For further information, please refer to <a href={`https://www.mcmc.gov.my/skmmgovmy/media/General/pdf2/GCC-Sub-Code-on-Opt-In-Requirements-1.pdf`} target="_blank">the full GCC Sub-Code on Opt-In Requirements</a> available on the MCMC website.</div>
                        </div>
                    </div>
                </section>
            </div>
            <div style={{ padding: "0px 5.208vw" }}>
                <Footer />
            </div>
        </div>
    );
};

export default Notifications;
